import 'react-toastify/dist/ReactToastify.css'

import { twMerge } from 'tailwind-merge'
import { useCallback, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router'
import { toast, ToastContainer } from 'react-toastify'

import { api, apiNoAuth } from '../services/api.service'

import AuxiliaryOwnershipDetails from '../components/auxiliary-product-details'
import Card from '../components/card'
import ChatStyleMessages from '../components/chat-style-messages'
import Loading from '../components/loading'
import LostModal from '../components/lostModal'
import RehomeConfirm from '../components/rehome-confirm'
import ReturnConfirm from '../components/return-confirm'
import S3FileViewer from '../components/S3Viewer'

import FindProductForm from '../forms/find-product-form'
import FormModal from '../forms/form-modal'
import LostProductForm from '../forms/lost-product-form'

import { style } from '../style'

// Configuration texts
const messages = {
    helpReturn: 'Thanks for helping return this item with Boomerang.',
    lost: "Uh oh! You've lost it.",
    helpOnTheWay: "Don't worry too much though, help is just around the corner. We feel it!",
    contactDetails: 'Just provide some contact details such as your phone number and name for the finder here.',
    anonymous: "If you don't leave any details, that's also OK, the finder will still be able to send an anonymous email to you with return details.",
    fingersCrossed: 'Our fingers and toes are crossed for you!',
    junkMail: "Make sure Boomerang is an authorised sender, we wouldn't want it to end up in your junk mail.",
    hero: 'Thanks for being a hero.',
}

export default function OwnershipDetails(props) {
    const [data, setData] = useState(null)
    const [userType, setUserType] = useState(null)
    const [user, setUser] = useState(null)
    const [showFindModal, setShowFindModal] = useState(false)
    const [showLostModal, setShowLostModal] = useState(false)
    const [showLostModalForFoundItem, setShowLostModalForFoundItem] = useState(false)
    const [submitted, setSubmitted] = useState(false)
    const params = useParams()
    const [confirmDisown, setConfirmDisown] = useState(false)
    const [confirmReturn, setConfirmReturn] = useState(false)
    const [messageRefreshKey, setMessageRefreshKey] = useState(0)
    const [initiatingCall, setInitiatingCall] = useState(false)
    const [finderPhoneNumber, setFinderPhoneNumber] = useState('')
    const navigate = useNavigate()

    const id = params.id ?? props.id

    useEffect(() => {
        apiNoAuth(`${process.env.REACT_APP_API_URL}/app/check-user-type`).then((x) => setUserType(x.userType))
    }, [])

    useEffect(() => {
        if (userType === 'merchant' || userType === 'user') {
            api(`${process.env.REACT_APP_API_URL}/app/get-current-user-details`).then((x) => setUser(x.user))
            api(`${process.env.REACT_APP_API_URL}/public/ownership/${id}`).then((x) =>
                api(`${process.env.REACT_APP_API_URL}/app/foundEvents/${id}`).then((y) => {
                    console.log('1', x)
                    if (x?.error === 'Ownership not found') {
                        navigate('/404')
                    }
                    setData({ ...x, foundEvent: y.foundEvent, foundEvents: y.allFoundEvents })
                })
            )
        } else {
            api(`${process.env.REACT_APP_API_URL}/public/ownership/${id}`).then((x) => {
                console.log('2', x)
                if (x?.error === 'Ownership not found') {
                    navigate('/404')
                }
                setData(x)
            })
        }
    }, [userType, id])

    const fetchData = useCallback(() => {
        api(`${process.env.REACT_APP_API_URL}/public/ownership/${id}`).then((x) => {
            console.log('3', x)
            if (x?.error === 'Ownership not found') {
                navigate('/404')
            }
            setData(x)
            setMessageRefreshKey((prev) => prev + 1)
        })
    }, [id])

    const markAsReturned = () => {
        api(`${process.env.REACT_APP_API_URL}/app/mark-as-returned/${id}`).then(fetchData)
        setConfirmReturn(false)
    }

    const claimItem = () => {
        api(`${process.env.REACT_APP_API_URL}/app/claim-product/${id}`).then(() => {
            fetchData()
        })
    }

    const disown = (id) => {
        api(`${process.env.REACT_APP_API_URL}/app/disown-product/${id}`).then(fetchData)
    }

    const refresh = () => {
        api(`${process.env.REACT_APP_API_URL}/public/ownership/${id}`).then((x) =>
            api(`${process.env.REACT_APP_API_URL}/app/foundEvents/${id}`).then((y) => {
                setData({ ...x, foundEvent: y.foundEvent, foundEvents: y.allFoundEvents })
                setMessageRefreshKey((prev) => prev + 1)
            })
        )
    }

    const getProductName = (item) => {
        if (!item.product && !item.name) {
            return 'Custom Item'
        } else if (!item.product) {
            return item.name
        } else {
            return item.product?.name
        }
    }

    const HandleButtonFlow = () => {
        const navigate = useNavigate()
        const { ownership } = data
        const isCurrentUserOwner = ownership.currentOwner?._id === user?._id
        if (ownership.currentOwner && !isCurrentUserOwner && !ownership.isLost)
            return (
                <button className={twMerge(style.button.classname, style.button._secondary.classname) + ' w-full text-xl'} onClick={() => setShowFindModal(true)}>
                    Found Me?
                </button>
            )
        if (user) {
            if (ownership.currentOwner) {
                if (isCurrentUserOwner) {
                    return (
                        <>
                            <button className={twMerge(style.button.classname, style.button._secondary.classname)} onClick={ownership.isLost || ownership.isFound ? () => setConfirmReturn(true) : () => setShowLostModal(true)}>
                                {ownership.isLost || ownership.isFound ? 'Returned' : 'Lost'}
                            </button>
                            <button
                                className={twMerge(style.button.classname, style.button._dark.classname)}
                                onClick={() => {
                                    setConfirmDisown(data.ownership._id)
                                }}
                            >
                                Rehome
                            </button>
                            <button
                                className={twMerge(style.button.classname, 'bg-light')}
                                onClick={() => {
                                    navigate(`/create-ownership/${data.ownership._id}`)
                                }}
                            >
                                Manage
                            </button>
                        </>
                    )
                }
            } else {
                return (
                    <button className={twMerge(style.button.classname, style.button._secondary.classname)} onClick={ownership.isCustom ? () => navigate(`/create-ownership/${id}?new=true`) : () => claimItem()}>
                        Claim Item
                    </button>
                )
            }
        } else {
            if (data.ownership.currentOwner) {
                if (!data.ownership.isLost) {
                    return (
                        <button className={twMerge(style.button.classname, style.button._secondary.classname)} onClick={() => setShowFindModal(true)}>
                            Found Me?
                        </button>
                    )
                }
            } else {
                return (
                    <>
                        <button className={twMerge(style.button.classname, style.button._primary.classname)} onClick={() => navigate('/register?rd=%2Fownership%2F' + id)}>
                            Register And Tag
                        </button>
                        <button className={twMerge(style.button.classname, style.button._secondary.classname)} onClick={() => navigate('/login?rd=%2Fownership%2F' + id)}>
                            Login And Tag
                        </button>
                    </>
                )
            }
        }
    }

    console.log(data)
    if (!data || !data.ownership) return <Loading />

    const PersonItemDisplay = ({ property, value, wrap }) => {
        if (property === 'Email') {
            return (
                <div className='flex flex-row space-x-2'>
                    <div className='font-bold'>{property}: </div>
                    <a href={`mailto:${value}`} className={'text-brand'}>
                        {value}
                    </a>
                </div>
            )
        } else if (property === 'Phone Number' || property === 'Phone') {
            return (
                <div className='flex flex-row space-x-2'>
                    <div className='font-bold'>{property}: </div>
                    <a href={`tel:${value}`} className={'text-brand'}>
                        {value}
                    </a>
                </div>
            )
        } else if (property === 'WhatsApp Number' || property === 'WhatsApp') {
            return (
                <div className='flex flex-row space-x-2'>
                    <div className='font-bold'>{property}: </div>
                    <a href={`https://wa.me/${value?.replace(/[^\d]/g, '')}`} className={'text-brand'}>
                        {value}
                    </a>
                </div>
            )
        } else {
            if (wrap) {
                return (
                    <div className='flex flex-col'>
                        <div className='font-bold'>{property}: </div>
                        <div className='flex-1 break-words text-brand'>{value}</div>
                    </div>
                )
            }

            return (
                <div className='flex flex-row space-x-2'>
                    <div className='font-bold'>{property}: </div>
                    <div className='flex-1 truncate text-brand'>{value}</div>
                </div>
            )
        }
    }

    const shouldShowPropertyWhenLost = (permissions, property) => {
        return permissions?.[property]?.showWhenLost || permissions?.[property]?.showAlways
    }

    const shouldShowPropertyAlways = (permissions, property) => {
        return permissions?.[property]?.showAlways
    }

    const userDetailDisplay = () => {
        const personalInfo = []
        const properties = [
            { field: 'name', label: 'First Name', isOverride: true },
            { field: 'lastName', label: 'Last Name', isOverride: true },
            { field: 'email', label: 'Email', isOverride: false },
            { field: 'phoneNumber', label: 'Phone', isOverride: false },
            { field: 'whatsappNumber', label: 'WhatsApp', isOverride: false },
        ]

        properties.forEach((property) => {
            let overrideValue = null
            let temporaryOverrideValue = null
            let customValue = null
            let temporaryCustomValue = null

            if (property.isOverride) {
                const overrideProperty = `override${property.field.charAt(0).toUpperCase() + property.field.slice(1)}`
                const temporaryOverrideProperty = `temporaryOverride${property.field.charAt(0).toUpperCase() + property.field.slice(1)}`
                overrideValue = data.ownership[overrideProperty]
                temporaryOverrideValue = data.ownership[temporaryOverrideProperty]
            } else {
                const customProperty = `custom${property.field.charAt(0).toUpperCase() + property.field.slice(1)}`
                const temporaryCustomProperty = `temporaryCustom${property.field.charAt(0).toUpperCase() + property.field.slice(1)}`
                customValue = data.ownership[customProperty]
                temporaryCustomValue = data.ownership[temporaryCustomProperty]
            }

            if (data.ownership.isLost) {
                if (data.ownership.temporaryOverridePermissions && data.ownership.temporaryOverridePermissions[property.field] !== undefined) {
                    if (shouldShowPropertyWhenLost(data.ownership.temporaryOverridePermissions, property.field)) {
                        const displayValue = temporaryCustomValue || temporaryOverrideValue || customValue || overrideValue || data.ownership.currentOwner[property.field]
                        personalInfo.push(<PersonItemDisplay property={property.label} value={displayValue} />)
                    }
                } else if (data.ownership.overridePermissions && data.ownership.overridePermissions[property.field] !== undefined) {
                    if (shouldShowPropertyWhenLost(data.ownership.overridePermissions, property.field)) {
                        const displayValue = temporaryCustomValue || temporaryOverrideValue || customValue || overrideValue || data.ownership.currentOwner[property.field]
                        personalInfo.push(<PersonItemDisplay property={property.label} value={displayValue} />)
                    }
                } else if (shouldShowPropertyWhenLost(data.ownership.currentOwner?.defaultPermissions, property.field)) {
                    const displayValue = temporaryCustomValue || temporaryOverrideValue || customValue || overrideValue || data.ownership.currentOwner[property.field]
                    personalInfo.push(<PersonItemDisplay property={property.label} value={displayValue} />)
                }
            } else {
                if (data.ownership.overridePermissions && data.ownership.overridePermissions[property.field] !== undefined) {
                    if (shouldShowPropertyAlways(data.ownership.overridePermissions, property.field)) {
                        const displayValue = temporaryCustomValue || temporaryOverrideValue || customValue || overrideValue || data.ownership.currentOwner[property.field]
                        personalInfo.push(<PersonItemDisplay property={property.label} value={displayValue} />)
                    }
                } else if (shouldShowPropertyAlways(data.ownership.currentOwner?.defaultPermissions, property.field)) {
                    const displayValue = temporaryCustomValue || temporaryOverrideValue || customValue || overrideValue || data.ownership.currentOwner[property.field]
                    personalInfo.push(<PersonItemDisplay property={property.label} value={displayValue} />)
                }
            }
        })
        return <div>{personalInfo.map((x) => x)}</div>
    }

    return (
        <div>
            <RehomeConfirm
                open={!!confirmDisown}
                confirm={() => {
                    disown(confirmDisown)
                    setConfirmDisown(false)
                }}
                cancel={() => {
                    setConfirmDisown(false)
                }}
            />
            <ReturnConfirm open={confirmReturn} confirm={markAsReturned} cancel={() => setConfirmReturn(false)} />

            <FormModal open={showFindModal} setOpen={setShowFindModal}>
                <div className='p-5 w-full max-w-xl bg-white rounded-md shadow'>
                    {/* <div className='w-full text-center'>{messages.helpReturn}</div> */}
                    <FindProductForm
                        submitted={(phoneNumber) => {
                            setSubmitted(true)
                            setFinderPhoneNumber(phoneNumber)
                            setShowFindModal(false)
                            // Refresh the page data to show the new chat interface
                            if (userType === 'merchant' || userType === 'user') {
                                refresh()
                            } else {
                                fetchData()
                            }
                        }}
                        id={id}
                        allowFinderGPS={
                            // First check if user has premium subscription
                            (data?.ownership?.currentOwner?.subscriptionType === 'standard_premium' || data?.ownership?.currentOwner?.subscriptionType === 'family_premium') &&
                            // Then check the permission hierarchy
                            (data?.ownership?.temporaryOverrideAllowFinderGPS !== undefined ? data?.ownership?.temporaryOverrideAllowFinderGPS : data?.ownership?.overrideAllowFinderGPS !== undefined ? data?.ownership?.overrideAllowFinderGPS : data?.ownership?.currentOwner?.allowFinderGPS !== false)
                        }
                    />
                </div>
            </FormModal>

            <FormModal open={showLostModalForFoundItem} setOpen={setShowLostModalForFoundItem}>
                <div className='p-5 w-full max-w-xl text-sm bg-white rounded-md shadow sm:text-base'>
                    <div className='mb-2 text-neutral-800'>Great news, someone has found your item!</div>
                    <div className='mb-2 text-neutral-800'>To get it back as soon as possible, we suggest leaving your name and contact number below for the finder to use.</div>
                    <div className='mb-2 text-neutral-800'>If you'd rather not share that information, they can also send you a message via Boomerang with return details. If that's the case, just make sure we're an authorised sender in your contacts, so that our email doesn't end up in your junk folder.</div>
                    <LostProductForm
                        submitted={() => {
                            setShowLostModalForFoundItem(false)
                            // Refresh to show the new message in the chat
                            refresh()
                        }}
                        id={id}
                    />
                </div>
            </FormModal>

            {user && data.ownership.currentOwner?._id === user?._id && <LostModal id={showLostModal ? id : ''} setId={setShowLostModal} refresh={refresh} />}

            <Card className='p-5 mt-10'>
                <ToastContainer autoClose={2000} position='bottom-right' />

                <div className='flex flex-col justify-evenly sm:space-x-8 sm:flex-row'>
                    <div className='shrink-0'>
                        <div className='text-sm text-neutral-600'> {data.ownership?.product?.brand || ''}</div>
                        <div className='mb-5 text-3xl font-black'>{getProductName(data.ownership)}</div>
                        {(data.ownership.s3Image || data.ownership.product?.s3Image) && <S3FileViewer className='object-cover w-64 h-64 rounded-md shadow' fileKey={data.ownership.product?.s3Image || data.ownership.s3Image} />}
                        {!data.ownership.isCustom && (data.ownership.size || data.ownership.category || data.ownership.colour || data.ownership.style || data.ownership.additionalDetails) && <AuxiliaryOwnershipDetails product={data.ownership.product} />}

                        <div className='flex flex-col items-start mt-10 space-y-3'>{<HandleButtonFlow />}</div>
                    </div>

                    <div className='mt-5 text-left text-neutral-700'>
                        {submitted && (
                            <div className='my-5 text-center'>
                                <div className='mb-4 text-xl font-bold text-brand'>Thanks for helping return this item with Boomerang, your message has been sent!</div>
                                {(data.ownership.currentOwner?.subscriptionType === 'standard_premium' || data.ownership.currentOwner?.subscriptionType === 'family_premium') && (data.ownership.temporaryOverrideAllowMaskedCalls !== undefined ? data.ownership.temporaryOverrideAllowMaskedCalls : data.ownership.overrideAllowMaskedCalls !== undefined ? data.ownership.overrideAllowMaskedCalls : data.ownership.currentOwner?.allowMaskedCalls !== false) && (
                                    <div className='p-4 mt-4 bg-blue-50 rounded-md border border-blue-200'>
                                        <div className='mb-3 text-sm text-neutral-700'>Need to speak with the owner immediately? You can call them now and your number will be protected.</div>
                                        <button
                                            className={twMerge(style.button.classname, style.button._dark.classname, 'w-full', initiatingCall && 'opacity-50 cursor-not-allowed')}
                                            onClick={() => {
                                                if (finderPhoneNumber) {
                                                    setInitiatingCall(true)
                                                    apiNoAuth(`${process.env.REACT_APP_API_URL}/public/initiate-call/${id}`, { finderPhoneNumber })
                                                        .then((response) => {
                                                            setInitiatingCall(false)
                                                            if (response.error) {
                                                                toast.error(response.error)
                                                            } else {
                                                                toast.success('Connecting both parties now! You will receive a call shortly.')
                                                            }
                                                        })
                                                        .catch((error) => {
                                                            setInitiatingCall(false)
                                                            toast.error('Failed to initiate call. Please try again.')
                                                        })
                                                }
                                            }}
                                            disabled={initiatingCall}
                                        >
                                            {initiatingCall ? 'Connecting...' : 'Call Owner Now (number protected)'}
                                        </button>
                                    </div>
                                )}
                            </div>
                        )}

                        {!data.ownership.isLost && (
                            <div className='mb-5'>
                                <div className='text-xl'>{userDetailDisplay()}</div>

                                <div className='text-xl'>
                                    {(() => {
                                        // Return instructions display logic - checking permissions hierarchy
                                        if (data.ownership.overridePermissions && data.ownership.overridePermissions['returnInstructions'] !== undefined) {
                                            if (shouldShowPropertyAlways(data.ownership.overridePermissions, 'returnInstructions')) {
                                                const displayValue = data.ownership.returnInstructions || data.ownership.currentOwner?.defaultReturnInstructions
                                                return <PersonItemDisplay property={'Return Instructions'} value={displayValue} wrap={true} />
                                            }
                                        } else if (shouldShowPropertyAlways(data.ownership.currentOwner?.defaultPermissions, 'returnInstructions')) {
                                            const displayValue = data.ownership.returnInstructions || data.ownership.currentOwner?.defaultReturnInstructions
                                            return <PersonItemDisplay property={'Return Instructions'} value={displayValue} wrap={true} />
                                        }
                                        return null
                                    })()}
                                </div>
                            </div>
                        )}

                        {!data.ownership.currentOwner?._id && (
                            <div>
                                <div className='text-xl font-medium text-neutral-800'>Welcome to Boomerang!</div>
                                <div className='mt-1 mb-3 text-lg'>Nametags just got smart.</div>
                                <div className='mt-1 mb-3 text-lg'>Say hi to BoomerangTag.</div>
                                <div className='mt-1 mb-3 text-lg'> Never lose this item again. {userType === 'anonymous' && 'Simply register and claim it!'}</div>
                            </div>
                        )}

                        {data.ownership.currentOwner?._id && data.ownership.currentOwner?._id !== user?._id && !data.ownership.isLost && (
                            <div>
                                <div className='text-xl font-medium text-neutral-800'>Have you found this item? Amazing!</div>
                                <div className='mt-1 mb-3 text-lg'>Tap "Found me?” and leave contact details so we can send details of how to return the item to its owner who will be very relieved!</div>
                                <div className='mt-1 mb-3 text-lg'>Thanks for being a hero.</div>
                                <div className='mt-1 mb-3 text-lg'>We're on a mission to save 100,000 items to reduce the giant pile of global lost property and help people reunite with their most loved belongings.</div>
                            </div>
                        )}
                        {data.ownership.currentOwner?._id !== user?._id && data.ownership.isLost && (
                            <div>
                                <div className='text-xl font-medium text-neutral-800'>Welcome to Boomerang!</div>
                                <div className='mt-1 mb-3 text-lg'>Thanks for finding this item. You are a HERO!</div>

                                {data.ownership.isFound && (
                                    <div className='mt-6 space-y-4'>
                                        <div className='pt-6 border-t'>
                                            <div className='mb-3 text-xl font-medium'>Conversation with Owner:</div>
                                            <ChatStyleMessages foundEvents={[]} foundEvent={null} ownership={data.ownership} user={user} viewerType='finder' onMessageFinder={() => setShowFindModal(true)} refreshTrigger={messageRefreshKey} />
                                        </div>
                                    </div>
                                )}

                                <button className={twMerge(style.button.classname, style.button._secondary.classname, 'mt-6 w-full')} onClick={() => setShowFindModal(true)}>
                                    Message owner
                                </button>

                                <div className='mt-6 mb-3 text-lg'>The owner has left these details to return their item:</div>
                                {data.ownership.isLost && (
                                    <div className='mb-5'>
                                        <div className='text-xl'>{userDetailDisplay()}</div>
                                    </div>
                                )}
                                <div className='mt-1 mb-3 text-lg font-semibold text-brand'>{data.ownership.returnInstructions || data.ownership.currentOwner?.defaultReturnInstructions}</div>
                            </div>
                        )}

                        {!data.ownership.isLost && !data.ownership.isFound && data.ownership.currentOwner?._id && data.ownership.currentOwner?._id === user?._id && (
                            <div>
                                <div className='text-xl font-medium text-neutral-800'>Hooray! You own this item</div>
                                <div className='mt-1 mb-3 text-lg'>We hope you will love this item like one of your own.</div>
                                <div className='mt-1 mb-3 text-lg'>If you lose it - and we really hope you don't - mark "Lost" to help the finder return the item. If the finder finds it first they will leave a note for you and an email to notify you.</div>
                                <div className='mt-1 mb-3 text-lg'>If you want to give the item to someone else, tap "Rehome" so the new owner can claim it.</div>
                                <div className='mt-1 mb-3 text-lg'>Tap "Manage" to adjust what is shown on this one item at any time or when marked lost. You can still adjust this at the time of losing if needed.</div>
                            </div>
                        )}
                        {data.ownership.isFound && user && data.ownership.currentOwner?._id === user?._id && (
                            <div className='space-y-4'>
                                <div className='text-xl font-medium'>Great news, someone has found your item!</div>
                                <div className='mt-1 text-neutral-700'>Here's the conversation with the hero who found it:</div>

                                <ChatStyleMessages foundEvents={data.foundEvents} foundEvent={data.foundEvent} ownership={data.ownership} user={user} viewerType='owner' onMessageFinder={() => setShowLostModalForFoundItem(true)} refreshTrigger={messageRefreshKey} />
                            </div>
                        )}
                        {data.ownership.currentOwner?._id === user?._id && data.ownership.isLost && !data.ownership.isFound && (
                            <>
                                <div className='mt-1 mb-3 text-lg'>Oh no! This item is lost. But fear not, Boomerang help is on the way.</div>
                                <div className='mt-1 mb-3 text-lg'>If someone finds it, they will contact you with the details you left to return the item and we'll email you as well.</div>
                                <div className='mt-1 mb-3 text-lg'>{messages.junkMail}</div>
                                <div className='mt-1 mb-3 text-lg'>{messages.fingersCrossed}</div>

                                <div className='mt-6'>
                                    <div className='mb-3 text-xs text-neutral-400'>Details you have left for the finder:</div>
                                    <ChatStyleMessages foundEvents={[]} foundEvent={null} ownership={data.ownership} user={user} showOnlyReturnInstructions={true} onMessageFinder={() => {}} />
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </Card>

            <ToastContainer autoClose={2000} position='bottom-right' />
        </div>
    )
}
